import * as React from "react";

function SvgEdit(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -9 34 34" width={24.824} height={24.798} {...props}>
        <path
          d="M20.694 0a1.923 1.923 0 00-1.368.567L8.657 11.231l-.048.048-.029.061-2.947 6.26a1.148 1.148 0 00.067 1.126 1.185 1.185 0 00.98.539 1.256 1.256 0 00.459-.094h.01l6.3-2.959.065-.032L24.227 5.462a1.931 1.931 0 000-2.736L22.066.564A1.935 1.935 0 0020.694 0zm.484 5.381l-1.77-1.771 1.284-1.284 1.77 1.774-1.284 1.281zM8.873 15.913l1.571-3.342 7.4-7.395 1.771 1.771-7.4 7.395-3.342 1.571zm14.845 6.671H1.106a1.107 1.107 0 000 2.214h22.612a1.107 1.107 0 000-2.214z"
          fill="#3c4252"
        />
      </svg>
    </span>
  );
}

export default SvgEdit;
